import React from "react";
import Button from "~/shared/Btn";
import DateIntervalInput from "~/shared/DateIntervalInput";
import createForm from "~/shared/Form";
import NumberInput from "~/shared/NumberInput";
import SelectInput from "~/shared/SelectInput";
import TextInput from "~/shared/TextInput";
import styled from "styled-components";
import Spinner from "~/shared/Spinner";
import Title from "~/shared/Title";
import useAuth from "~/hooks/useAuth";

const Container = styled.div`
    .align {
        display: flex;
        align-items: center;
        margin-top: -1rem;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;

    button {
        max-width: 7rem;
    }
`;
const [Field, Form] = createForm(
    {
        id: {
            placeholder: "Id do Job",
            component: NumberInput,
        },
        customerCode: {
            placeholder: "Código do cliente",
            component: TextInput,
        },
        correlationId: {
            placeholder: "Id de Correlação",
            component: TextInput,
        },
        address: {
            placeholder: "Endereço",
            component: TextInput,
        },
        date: {
            placeholder: "Data da solicitação",
            component: DateIntervalInput,
        },
    },
    {}
);

type RequestFilterProps = {
    onFilter: (data: Record<string, any>) => Promise<any>;
    defaultData?: Record<string, any>;
    loadJobs: boolean;
};

const Filters = ({ onFilter, defaultData = {}, loadJobs }: RequestFilterProps) => {
    const { account } = useAuth();
    return (
        <Form
            onSubmit={onFilter}
            renderButton={() => (
                <ButtonContainer>
                    <Button type="submit" disabled={loadJobs}>
                        {loadJobs ? <Spinner /> : "Buscar"}
                    </Button>
                </ButtonContainer>
            )}
            initialData={defaultData}
        >
            <Container className="row">
                <div className="col-12">
                    <Title level="3">Filtrar job</Title>
                </div>
                <div className="col-lg-3">
                    <Field name="id" />
                </div>
                <div className="col-lg-3">
                    {account?.organization.id === 14 ? <Field name="correlationId" /> : <Field name="customerCode" />}
                </div>
                <div className="col-lg-3">
                    <Field name="address" />
                </div>
                <div className="col-lg-3">
                    <Field name="date" />
                </div>
            </Container>
        </Form>
    );
};

export default Filters;
